import runePlate from "../assets/runePlate.png";
import styles from "../Components/runeAltarStyles.module.scss";
import useGame from "../RunicMemoriseContext";

type altarProps = {
  rune: string;
  id: number;
  ilumination: boolean;
};

const RuneAltar: React.FC<altarProps> = ({ rune, id, ilumination }) => {
  const { setCheckInputArray, simonState } = useGame();
  return (
    <div data-testid='RuneAltar' className={styles.altar}>
      <button
        type='button'
        onClick={() => {
          if (simonState === "simonHace") {
            setCheckInputArray(prev => [...prev, rune]);
          }
        }}
        className={styles.runicButton}>
        <img
          key={`I${id}`}
          className={`${styles.runicStone} ${
            ilumination ? styles.iluminate : ""
          }`}
          src={rune}
          alt='rune'
        />
      </button>
      <img
        className={styles.runicStonePlate}
        src={runePlate}
        alt='rune plate'
      />
    </div>
  );
};
export default RuneAltar;
